(function(){
  'use strict';
  // AZO 2026-09-24 samples. Data comes from snippets/az-sample-offers.liquid. This file owns:
  // the shared sample recommendation (window.AZSamples, read by the cart drawer chooser),
  // the one-tap sample button on product pages and the two recommendations on /cart.
  var source=document.getElementById('az-sample-data');
  if(!source)return;
  var cfg=JSON.parse(source.textContent), products=cfg.products, en=String(cfg.language||'').indexOf('en')===0;
  var root=(cfg.root||'/').replace(/\/?$/,'/'), lastCart=null, busy=false, observed=null;
  var freeIds=[53792738509107,53716614283571,53716614316339], oldPaidIds=[53715688882483,53715688915251];
  var byKey={};products.forEach(function(p){byKey[p.key]=p;});

  var TEXT={
    ARGAN:{bs:['Arganovo ulje','za lice, kosu i tijelo'],en:['Argan oil','for face, hair and body']},
    SANOUJ:{bs:['SANOUJ','ulje crnog kima'],en:['SANOUJ','black seed oil']},
    AFOULKI:{bs:['AFOULKI','krema za lice'],en:['AFOULKI','face cream']},
    AZGGAGH:{bs:['AZGGAGH','boja za usne i obraze'],en:['AZGGAGH','lip and cheek colour']},
    TIFAWT:{bs:['TIFAWT','maska za lice'],en:['TIFAWT','face mask']},
    TAFUKT:{bs:['TAFUKT','piling za tijelo'],en:['TAFUKT','body polish']},
    ALJIG:{bs:['ALJIG','gel za tuširanje'],en:['ALJIG','shower gel']},
    ANU:{bs:['ANU','mlijeko za tijelo'],en:['ANU','body milk']},
    IHLA:{bs:['IHLA','šampon'],en:['IHLA','shampoo']},
    LHRIR:{bs:['LHRIR','regenerator'],en:['LHRIR','conditioner']}
  };
  // One reason per recommendation: what the sample is for, next to what is already in the cart.
  var WHY={
    'AZGGAGH>AFOULKI':['krema za lice uz tvoju boju za usne i obraze','face cream to go with your lip and cheek colour'],
    'TIFAWT>AFOULKI':['krema za lice poslije maske','face cream for after the mask'],
    'AFOULKI>TIFAWT':['maska za lice uz tvoju kremu','face mask to go with your cream'],
    'ANNAY>AFOULKI':['krema za lice uz tvoj serum','face cream to go with your serum'],
    'FACESET>TIFAWT':['maska za lice uz tvoj set','face mask to go with your set'],
    'ARGAN>SANOUJ':['hladno cijeđeno ulje crnog kima','cold-pressed black seed oil'],
    'SANOUJ>ARGAN':['arganovo ulje za lice, kosu i tijelo','argan oil for face, hair and body'],
    'SANOUJ>ANU':['mlijeko za tijelo poslije tuširanja','body milk for after your shower'],
    'ALJIG>ANU':['mlijeko za tijelo poslije tuširanja','body milk for after your shower'],
    'ANU>ALJIG':['gel za tuširanje uz tvoje mlijeko','shower gel to go with your body milk'],
    'TAFUKT>ANU':['mlijeko za tijelo poslije pilinga','body milk for after the polish'],
    'TAFUKT>ALJIG':['gel za tuširanje uz tvoj piling','shower gel to go with your polish'],
    'ALJIG>TAFUKT':['piling za tijelo uz tvoj gel','body polish to go with your shower gel'],
    'ANU>TAFUKT':['piling za tijelo uz tvoje mlijeko','body polish to go with your body milk'],
    'IHLA>LHRIR':['regenerator uz tvoj šampon','conditioner to go with your shampoo'],
    'LHRIR>IHLA':['šampon uz tvoj regenerator','shampoo to go with your conditioner'],
    'IHLA>ARGAN':['ulje za vrhove kose, lice i tijelo','oil for hair ends, face and body'],
    'LHRIR>ARGAN':['ulje za vrhove kose, lice i tijelo','oil for hair ends, face and body'],
    'HAIRSET>ARGAN':['ulje za vrhove kose, lice i tijelo','oil for hair ends, face and body']
  };
  var FULL={
    '100-arganovo-ulje':'ARGAN','sanouj':'SANOUJ','afoulki':'AFOULKI',
    'azggagh-aker-fassi-poppy-lip-cheek-tint-balm':'AZGGAGH','tifawt-blue-nila-prickly-pear-illuminating-mask':'TIFAWT',
    'tafukt-coffee-argan-resurfacing-body-polish':'TAFUKT','aljig-orange-blossom-glycerin-body-wash':'ALJIG',
    'anu-orange-blossom-water-argan-body-milk':'ANU','ihla-regeneracijski-sampon':'IHLA','lhrir-argan-avocado-silk-conditioner':'LHRIR',
    'annay-serum-za-trepavice-i-obrve':'ANNAY','set-za-lice-krema-boja-i-njega-obrva':'FACESET','ihla-lhrir-ritual-za-kosu':'HAIRSET'
  };
  var CONTAINS={FACESET:['AFOULKI','AZGGAGH','ANNAY'],HAIRSET:['IHLA','LHRIR']};
  var RECS={
    AZGGAGH:['AFOULKI','TIFAWT'],TIFAWT:['AFOULKI','AZGGAGH'],AFOULKI:['TIFAWT','ARGAN'],ARGAN:['SANOUJ','AFOULKI'],
    SANOUJ:['ARGAN','ANU'],ALJIG:['ANU','TAFUKT'],ANU:['ALJIG','TAFUKT'],TAFUKT:['ANU','ALJIG'],IHLA:['LHRIR','ARGAN'],
    LHRIR:['IHLA','ARGAN'],ANNAY:['AFOULKI','AZGGAGH'],FACESET:['TIFAWT','ARGAN'],HAIRSET:['ARGAN','SANOUJ']
  };
  var FALLBACK=['ARGAN','AFOULKI','TIFAWT','AZGGAGH','SANOUJ','ANU','ALJIG','TAFUKT','IHLA','LHRIR'];

  function vid(i){return Number(i.variant_id||i.id);}
  function isGiftLine(i){var id=vid(i);return freeIds.indexOf(id)>=0 || !!(i.properties && i.properties._az_auto_gift==='1');}
  function sellable(p){return !!p && p.available && Number(p.price)===500;}
  function text(p){var t=TEXT[p.key]||{bs:[p.key,''],en:[p.key,'']};return en?t.en:t.bs;}
  function path(p){return root+'products/'+p.sampleHandle;}
  function money(n){n=Number(n)/100;return (n%1?n.toFixed(2).replace('.',','):String(n))+' KM';}

  // Which products the cart already holds, as sample keys.
  function holdings(cart){
    var full={},samples={},counts={},sources=[];
    var lines=(cart&&cart.items?cart.items:[]).filter(function(i){return !isGiftLine(i);});
    lines.forEach(function(i){
      var id=vid(i);
      products.forEach(function(p){if(p.id===id){samples[p.key]=1;counts[id]=(counts[id]||0)+i.quantity;}});
      if(id===oldPaidIds[0])samples.ARGAN=1;
      if(id===oldPaidIds[1])samples.SANOUJ=1;
    });
    (cart&&cart.items?cart.items:[]).forEach(function(i){
      if(vid(i)===freeIds[1])samples.ARGAN=1;
      if(vid(i)===freeIds[2])samples.SANOUJ=1;
    });
    lines.filter(function(i){return FULL[i.handle];}).sort(function(a,b){return Number(b.final_price||b.price)-Number(a.final_price||a.price);}).forEach(function(i){
      var k=FULL[i.handle];
      if(sources.indexOf(k)<0)sources.push(k);
      full[k]=1;(CONTAINS[k]||[]).forEach(function(c){full[c]=1;});
    });
    return {full:full,samples:samples,counts:counts,sources:sources};
  }

  // Two complements for the highest-priced full-size item, then the next item, then the house pair.
  // Never a sample already in the cart (unless kept), never a product she already has in full size
  // unless nothing else fits, never a product excluded by the caller (the drawer's full-size suggestion).
  function recommend(cart,opts){
    opts=opts||{};
    var h=holdings(cart), exclude=opts.exclude||{}, keep=opts.keep||{}, out=[], seen={};
    var queue=[];
    h.sources.forEach(function(s){(RECS[s]||[]).forEach(function(k){queue.push({k:k,from:s});});});
    FALLBACK.forEach(function(k){queue.push({k:k,from:''});});
    function pass(allowFull){
      queue.forEach(function(q){
        if(out.length>=2 || seen[q.k])return;
        var p=byKey[q.k];
        if(!sellable(p) || exclude[q.k])return;
        if(h.samples[q.k] && !keep[p.id])return;
        if(h.full[q.k] && !allowFull)return;
        seen[q.k]=1;
        var why=WHY[q.from+'>'+q.k];
        out.push({product:p,why:why?(en?why[1]:why[0]):text(p)[1]});
      });
    }
    pass(false);if(out.length<2)pass(true);
    return out;
  }

  window.AZSamples={products:products,en:en,root:root,text:text,path:path,money:money,sellable:sellable,holdings:holdings,recommend:recommend,byKey:byKey};
  try{document.dispatchEvent(new CustomEvent('az:samples-ready'));}catch(_){}

  function el(tag,cls,t){var x=document.createElement(tag);if(cls)x.className=cls;if(t)x.textContent=t;return x;}

  // Product page: one tap adds this product's own sample and opens the cart.
  function pdp(){
    var handle=location.pathname.split('/products/')[1];if(!handle)return;handle=handle.split('/')[0].split('?')[0];
    var p=products.find(function(x){return x.handle===handle && sellable(x);});
    var form=document.querySelector('form.az-os-buy__form[data-az-os-add-form]');
    if(!p || !form || document.querySelector('.az-sample-cta'))return;
    var wrap=el('div','az-sample-cta');
    var idle=(en?'Try a sample':'Isprobaj uzorak')+' · '+p.size+' · '+money(p.price);
    var done=en?'The sample is in your cart':'Uzorak je u korpi';
    var btn=el('button','az-sample-link',idle);btn.type='button';btn.setAttribute('data-az-sample-id',p.id);
    var all=el('a','az-sample-all',en?'All samples':'Svi uzorci');all.href=root+'collections/uzorci';
    var status=el('span','az-sample-cta__status');status.setAttribute('role','status');
    wrap.appendChild(btn);wrap.appendChild(all);wrap.appendChild(status);
    form.insertAdjacentElement('afterend',wrap);
    var inCart=false;
    function show(cart){
      inCart=!!(cart && cart.items && cart.items.some(function(i){return vid(i)===p.id;}));
      btn.textContent=inCart?'✓ '+done:idle;
      btn.classList.toggle('is-in-cart',inCart);
    }
    document.addEventListener('az:cart-settled',function(e){show(e.detail);});
    btn.addEventListener('click',function(){
      if(btn.getAttribute('aria-busy')==='true')return;
      if(!window.AZCart || !window.AZCart.add){location.href=path(p);return;}
      if(inCart){window.AZCart.open();return;}
      status.textContent='';
      btn.setAttribute('aria-busy','true');
      var f=el('form');f.method='post';f.action=root+'cart/add';
      var a=el('input');a.type='hidden';a.name='id';a.value=p.id;f.appendChild(a);
      var q=el('input');q.type='hidden';q.name='quantity';q.value='1';f.appendChild(q);
      Promise.resolve(window.AZCart.add(f)).then(function(){
        btn.removeAttribute('aria-busy');
        if(!inCart){status.textContent=en?'Please try again.':'Pokušaj ponovo.';return;}
        var drawer=document.getElementById('AZMiniCart');
        if(drawer && !drawer.classList.contains('is-open'))window.AZCart.open();
      },function(){btn.removeAttribute('aria-busy');status.textContent=en?'Please try again.':'Pokušaj ponovo.';});
    });
  }

  // /cart page: two recommendations, same logic as the drawer.
  function select(cart){
    if(!cart || cart.currency!=='BAM' || !cart.items || !cart.items.length)return [];
    // Order discounts can be entered at checkout. Do not guess which new item they cover.
    if(Number(cart.total_discount)>0)return [];
    var total=Number(cart.total_price);
    if(!Number.isFinite(total))return [];
    return recommend(cart).filter(function(r){
      // A 5 KM addition cannot repay the lost 8 KM delivery charge at this threshold.
      return !(total<5900 && total+Number(r.product.price)>=5900);
    });
  }
  function display(cart){
    lastCart=cart;
    var items=document.querySelector('#AzCart [data-azc-items]');if(!items)return;
    var column=items.parentElement;
    if(!column.classList.contains('az-sample-column')){column=el('div','az-sample-column');items.before(column);column.appendChild(items);}
    var box=column.querySelector('.az-sample-offers');if(!box){box=el('section','az-sample-offers');column.appendChild(box);}
    if(busy)return;
    box.replaceChildren();var offers=select(cart);box.hidden=!offers.length;if(!offers.length)return;
    box.appendChild(el('h2','',en?'Try a sample with your order':'Probaj uzorak uz narudžbu'));
    offers.forEach(function(r){
      var p=r.product,t=text(p);
      var row=el('div','az-sample-offer'),img=el('img');img.src=p.image;img.alt='';img.width=80;img.height=88;img.loading='lazy';row.appendChild(img);
      var info=el('div','az-sample-offer__info'),a=el('a','',t[0]+' · '+p.size);a.href=path(p);info.appendChild(a);info.appendChild(el('small','',r.why+' · '+money(p.price)));row.appendChild(info);
      var form=el('form');form.method='post';form.action=root+'cart/add';var input=el('input');input.type='hidden';input.name='id';input.value=p.id;form.appendChild(input);
      var qty=el('input');qty.type='hidden';qty.name='quantity';qty.value='1';form.appendChild(qty);
      var button=el('button','',en?'Add':'Dodaj');button.type='button';button.setAttribute('aria-label',(en?'Add sample: ':'Dodaj uzorak: ')+t[0]);form.appendChild(button);row.appendChild(form);box.appendChild(row);
      button.addEventListener('click',function(){
        if(busy || !window.AZCart || !window.AZCart.add || !window.AZCart.settle)return;
        busy=true;box.querySelectorAll('button').forEach(function(b){b.disabled=true;});
        var old=lastCart.items.reduce(function(n,i){return n+(vid(i)===p.id?i.quantity:0);},0);
        Promise.resolve(window.AZCart.add(form)).then(function(){return window.AZCart.settle();}).then(function(now){
          var count=now.items.reduce(function(n,i){return n+(vid(i)===p.id?i.quantity:0);},0);
          if(count<=old)throw new Error('sample-not-added');
          // Cart section, totals and next offer all come from the same fresh server render.
          location.reload();
        }).catch(function(){busy=false;display(lastCart);var s=document.querySelector('.az-sample-status');if(s)s.textContent=en?'Check your cart before trying again.':'Provjeri korpu prije ponovnog pokušaja.';});
      });
    });
    var status=el('p','az-sample-status');status.setAttribute('role','status');box.appendChild(status);
  }
  // /collections/uzorci cards: show which samples are already in the cart; a second tap opens the cart.
  function cards(cart){
    document.querySelectorAll('form[data-az-sample-card]').forEach(function(f){
      var input=f.querySelector('[name="id"]'), b=f.querySelector('button');if(!input || !b)return;
      var id=Number(input.value), has=!!(cart && cart.items && cart.items.some(function(i){return vid(i)===id;}));
      if(!b.hasAttribute('data-idle'))b.setAttribute('data-idle',b.textContent);
      b.textContent=has?'✓ '+(en?'In your cart':'U korpi'):b.getAttribute('data-idle');
      b.classList.toggle('is-in-cart',has);
      if(has)f.setAttribute('data-in-cart','');else f.removeAttribute('data-in-cart');
    });
  }
  document.addEventListener('az:cart-settled',function(e){cards(e.detail);});
  window.addEventListener('submit',function(e){
    var f=e.target;
    if(f && f.matches && f.matches('form[data-az-sample-card][data-in-cart]') && window.AZCart && window.AZCart.open){e.preventDefault();e.stopImmediatePropagation();window.AZCart.open();}
  },true);
  pdp();
  if(document.getElementById('AzCart')){
    document.addEventListener('az:cart-settled',function(e){display(e.detail);});
    // Existing cart code can replace the section after quantity or gift changes.
    observed=new MutationObserver(function(){if(lastCart && document.querySelector('#AzCart [data-azc-items]') && !document.querySelector('#AzCart .az-sample-column'))display(lastCart);});
    observed.observe(document.getElementById('AzCart'),{childList:true,subtree:true});
    fetch(root+'cart.js',{credentials:'same-origin'}).then(function(r){if(!r.ok)throw new Error('cart');return r.json();}).then(display).catch(function(){});
  }
})();
